import UpdateIcon from '@mui/icons-material/Update';
import { ClosableBanner } from '@src/common/components/ClosableBanner';
import { Stack } from '@src/common/components/Stack';
import { Typography } from '@src/common/components/Typography';
import { theme } from '@src/common/styles/Theme';
import { useTranslation } from 'react-i18next';

export const LastUpdatedBanner = () => {
  const { t } = useTranslation();

  return (
    <ClosableBanner severity="warning" style={bannerStyle}>
      <Stack direction="row" spacing={theme.spacing[2]}>
        <UpdateIcon />
        <Typography variant="body2">{t('lastUpdatedBanner')}</Typography>
      </Stack>
    </ClosableBanner>
  );
};

const bannerStyle = {
  position: 'absolute',
  top: theme.spacing[8],
  maxWidth: 520,
  border: 'none',
  alignSelf: 'flex-end',
};
